module.exports = __webpack_public_path__ + "img/Best of Deutschschweiz weiss.c0add24e.jpg";